import React from 'react'
import { DateTime } from 'luxon'
import type { LastBlastSourceKey } from '../../../Generated/LastBlastSource.ts'
import { formatDate, parseDate } from '../../../Util/DateHandling.js'

const SOURCE_LABEL: Record<LastBlastSourceKey, string> = {
  EVALUATION: 'pipeline run',
  REBLAST: 're-annotation sweep',
}

/**
 * When the SPIN's representative sequence was last BLASTed, with its age and which evidence that was.
 * Shared by the public `/spins/{id}` page and the admin SPIN detail page.
 */
export const LastBlasted: React.FC<{ at?: string; source?: LastBlastSourceKey; now?: DateTime }> = ({
  at,
  source,
  now,
}) => {
  if (!at) {
    return <span>—</span>
  }
  const parsed = parseDate(at)
  const age = typeof parsed === 'string' ? null : parsed.toRelative({ base: now ?? DateTime.now() })
  return (
    <span>
      {formatDate(parsed)}
      {age && <span className="text-gray-500"> ({age})</span>}
      {source && <span className="block text-xs text-gray-400">via {SOURCE_LABEL[source]}</span>}
    </span>
  )
}
